var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS3P2BImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 110,
    viewBox: "0 0 108 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77148 82.9939L62.9181 47.2147L105.384 72.4763L45.2375 108.255L2.77148 82.9939Z",
    fill: "#2B34A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 41.0833L60.6466 5.30405V43.3074L0.5 79.0866V41.0833Z",
    fill: "#1E1E1E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.5157,
    height: 35.8626,
    transform: "matrix(0.859433 0.511248 0 1 60.6465 5.30322)",
    fill: "url(#paint0_linear_579_753)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5283 7.14331L81.0697 13.4141L82.9847 14.5533L91.611 19.6848V59.2056L70.5283 46.6642V7.14331Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3525 2.25439L70.984 16.3121L75.2771 18.8659L94.6155 30.3696V69.8904L47.3525 41.7753V2.25439Z",
    fill: "#F2B710"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4395 0L64.0709 14.0577L68.364 16.6115L87.7024 28.1152V67.636L40.4395 39.5209V0Z",
    fill: "url(#paint1_linear_579_753)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8075 10.103L57.439 24.1607L61.732 26.7145L81.0705 38.2183L77.6496 77.7392L30.3867 49.6241L33.8075 10.103Z",
    fill: "#4853DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2202 13.3589L52.8517 27.4166L57.1447 29.9703L76.4832 41.4741V80.9949L29.2202 52.8798V13.3589Z",
    fill: "#FFF3D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9258 15.4234L47.5572 29.4811L51.8503 24.2036L71.1887 35.7074L75.5033 83.0594L28.2404 54.9443L23.9258 15.4234Z",
    fill: "url(#paint2_linear_579_753)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 21.1651L38.2969 35.2227L42.5899 37.7765L61.9284 49.2803L58.5076 88.8012L11.2446 60.6861L14.6654 21.1651Z",
    fill: "#BF2F2F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0791 24.4199L33.7106 38.4776L38.0036 41.0314L57.342 52.5352V92.0559L10.0791 63.9408V24.4199Z",
    fill: "#FFF3D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78516 26.4849L28.4166 40.5426L32.7097 35.2652L52.0481 46.7689L56.3627 94.1209L9.09979 66.0058L4.78516 26.4849Z",
    fill: "url(#paint3_linear_579_753)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4023 69.5188L107.5 33.1741V70.4913C107.5 71.5959 106.73 72.9491 105.781 73.5138L46.4023 108.836V69.5188Z",
    fill: "url(#paint4_linear_579_753)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 41.0833L47.3526 68.9543V108C47.3526 109.105 46.583 109.542 45.6337 108.978L2.21887 83.1517C1.26956 82.587 0.5 81.2338 0.5 80.1292V41.0833Z",
    fill: "#454545"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24.2852,
    height: 7.90089,
    rx: 3.95044,
    transform: "matrix(0.859433 0.511248 0 1 11.2437 57.4775)",
    fill: "url(#paint5_linear_579_753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_579_753",
    x1: 27.2578,
    y1: 0,
    x2: 27.2578,
    y2: 35.8626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_579_753",
    x1: 64.0709,
    y1: 14.0576,
    x2: 46.7061,
    y2: 43.2487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#988F60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_579_753",
    x1: 49.7146,
    y1: 22.9332,
    x2: 21.2874,
    y2: 114.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#3A44B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_579_753",
    x1: 30.5739,
    y1: 33.9947,
    x2: 9.79724,
    y2: 98.9707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_579_753",
    x1: 76.9509,
    y1: 51.3465,
    x2: 94.2263,
    y2: 80.3871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#340000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_579_753",
    x1: 12.1426,
    y1: 0,
    x2: 12.1426,
    y2: 7.90089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS3P2BImg1);
export default __webpack_public_path__ + "static/media/HomeS3P2BImg1.daaf5c1a31298b7801a9879d4ac8afb5.svg";
export { ForwardRef as ReactComponent };